import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { useAnimatedScroll } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/useAnimatedScroll";
import { PillWithContent } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/PillWithContentComponent/PillWithContent";
import { CategoryBestBrandsBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/CategoryBestBrandsBanner/CategoryBestBrandsBanner";
import { CategoryBestBrandsWithCTA } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/CategoryBestBrandsBannerV2/__internal__/CategoryBestBrandsWithCTA";
import { useCategoryBrandsBannerQuery } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/DataFetching/useCategoryBrandsBannerQuery";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { ICategoryBrandsCarousel } from "@faire/web-api--source/indigofair/data/ICategoryBrandsCarousel";
import React from "react";
var ITEMS_PER_ROW_RESPONSIVE = {
    mobileAndAbove: 4,
    desktopAndAbove: 5,
    xLargeAndAbove: 6
};
export var CategoryBestBrandsWithV2Design = function(param) {
    var loadTimingRef = param.loadTimingRef;
    var isHomepageRedesignV2 = useIsLoggedOutHomepageRedesignV2();
    if (isHomepageRedesignV2) {
        return /*#__PURE__*/ _jsx(CategoryBestBrandsV2, {
            loadTimingRef: loadTimingRef
        });
    }
    return /*#__PURE__*/ _jsx(CategoryBestBrandsBanner, {
        loadTimingRef: loadTimingRef
    });
};
var CategoryBestBrandsV2 = function(param) {
    var loadTimingRef = param.loadTimingRef;
    var _selectedCategory_large_brand_tiles;
    var _useCategoryBrandsBannerQuery = useCategoryBrandsBannerQuery(), categoryBestBrands = _useCategoryBrandsBannerQuery.categoryBestBrands, isFetching = _useCategoryBrandsBannerQuery.isFetching;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _categoryBestBrands_length;
    var _useAnimatedScroll = useAnimatedScroll((_categoryBestBrands_length = categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands.length) !== null && _categoryBestBrands_length !== void 0 ? _categoryBestBrands_length : 0, 5000), resumeScroll = _useAnimatedScroll.resumeScroll, pauseScroll = _useAnimatedScroll.pauseScroll, currentIndex = _useAnimatedScroll.currentIndex, setCurrentIndex = _useAnimatedScroll.setCurrentIndex, isVisible = _useAnimatedScroll.isVisible;
    var itemsPerRow = useResponsiveValue(ITEMS_PER_ROW_RESPONSIVE);
    var selectedCategory = categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands[currentIndex];
    var slicedSelectedCategory = ICategoryBrandsCarousel.build(_object_spread_props(_object_spread({}, selectedCategory), {
        large_brand_tiles: selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory_large_brand_tiles = selectedCategory.large_brand_tiles) === null || _selectedCategory_large_brand_tiles === void 0 ? void 0 : _selectedCategory_large_brand_tiles.slice(0, itemsPerRow)
    }));
    var _categoryBestBrands_map;
    var tabs = (_categoryBestBrands_map = categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands.map(function(param) {
        var category_name = param.category_name, category_path_identifier = param.category_path_identifier, category_cta_link = param.category_cta_link, category_cta_link_text = param.category_cta_link_text;
        return {
            tabName: category_name,
            pathIdentifier: category_path_identifier,
            ctaLink: category_cta_link,
            ctaLinkText: category_cta_link_text
        };
    })) !== null && _categoryBestBrands_map !== void 0 ? _categoryBestBrands_map : [];
    if (isFetching) {
        return /*#__PURE__*/ _jsx(LoadingSkeleton, {
            height: "600px",
            width: "100%"
        });
    }
    if (!(categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands.length) || !selectedCategory) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PillWithContent, {
        title: strictLocalize({
            id: "bej9JA",
            defaultMessage: [
                {
                    type: 0,
                    value: "Featured brands"
                }
            ]
        }),
        tabs: tabs,
        eventTrackingName: "category_best_brands_banner",
        loadTimingRef: loadTimingRef,
        pauseScroll: pauseScroll,
        resumeScroll: resumeScroll,
        currentIndex: currentIndex,
        setCurrentIndex: setCurrentIndex,
        isVisible: isVisible,
        children: /*#__PURE__*/ _jsx(_Fragment, {
            children: isRobot() ? /*#__PURE__*/ _jsx(BotCategories, {
                categoryBestBrands: categoryBestBrands
            }) : /*#__PURE__*/ _jsx(CategoryBestBrandsWithCTA, {
                selectedCategory: slicedSelectedCategory,
                pauseScroll: pauseScroll,
                resumeScroll: resumeScroll
            })
        })
    });
};
var BotCategories = function(param) {
    var categoryBestBrands = param.categoryBestBrands;
    return(// we want to have all categories in the DOM for prerendering
    /*#__PURE__*/ _jsx(_Fragment, {
        children: categoryBestBrands.map(function(category, index) {
            return /*#__PURE__*/ _jsx(CategoryBestBrandsWithCTA, {
                selectedCategory: category,
                className: index ? "invisible h-0" : ""
            }, index);
        })
    }));
};
